<p
    class="default-paragraph"
    [innerHTML]="'dynamische_frontend_texte.barrierefreiheit_erklaerung.text' | translate | safeStyle"
></p>
